import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=7670a32b&"
import script from "./KanbanView.vue?vue&type=script&lang=js&"
export * from "./KanbanView.vue?vue&type=script&lang=js&"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=7670a32b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports